"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var Cycling = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Cycling, _React$PureComponent);

  var _super = (0, _createSuper2["default"])(Cycling);

  function Cycling() {
    (0, _classCallCheck2["default"])(this, Cycling);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Cycling, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], this.props, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M15.2083333,5.70731707 C16.2166667,5.70731707 17.0416667,4.87317073 17.0416667,3.85365854 C17.0416667,2.83414634 16.2166667,2 15.2083333,2 C14.2,2 13.375,2.83414634 13.375,3.85365854 C13.375,4.87317073 14.2,5.70731707 15.2083333,5.70731707 Z M5.58333333,11.7317073 C3.01666667,11.7317073 1,13.7707317 1,16.3658537 C1,18.9609756 3.01666667,21 5.58333333,21 C8.15,21 10.1666667,18.9609756 10.1666667,16.3658537 C10.1666667,13.7707317 8.15,11.7317073 5.58333333,11.7317073 Z M5.58333333,19.6097561 C3.84166667,19.6097561 2.375,18.1268293 2.375,16.3658537 C2.375,14.604878 3.84166667,13.1219512 5.58333333,13.1219512 C7.325,13.1219512 8.79166667,14.604878 8.79166667,16.3658537 C8.79166667,18.1268293 7.325,19.6097561 5.58333333,19.6097561 Z M10.9,10.3414634 L13.1,8.11707317 L13.8333333,8.85853659 C14.805,9.84097561 16.015,10.5082927 17.4633333,10.7307317 C18.0133333,10.8141463 18.5083333,10.3692683 18.5083333,9.80390244 C18.5083333,9.3497561 18.1691667,8.9604878 17.7291667,8.88634146 C16.7116667,8.7195122 15.8775,8.22829268 15.2083333,7.56097561 L13.4666667,5.8 C13.0083333,5.42926829 12.55,5.24390244 12,5.24390244 C11.45,5.24390244 10.9916667,5.42926829 10.7166667,5.8 L8.15,8.39512195 C7.78333333,8.76585366 7.6,9.22926829 7.6,9.69268293 C7.6,10.2487805 7.78333333,10.7121951 8.15,10.9902439 L11.0833333,13.5853659 L11.0833333,17.2926829 C11.0833333,17.802439 11.4958333,18.2195122 12,18.2195122 C12.5041667,18.2195122 12.9166667,17.802439 12.9166667,17.2926829 L12.9166667,13.2146341 C12.9166667,12.7326829 12.7333333,12.2785366 12.4125,11.9356098 L10.9,10.3414634 Z M18.4166667,11.7317073 C15.85,11.7317073 13.8333333,13.7707317 13.8333333,16.3658537 C13.8333333,18.9609756 15.85,21 18.4166667,21 C20.9833333,21 23,18.9609756 23,16.3658537 C23,13.7707317 20.9833333,11.7317073 18.4166667,11.7317073 Z M18.4166667,19.6097561 C16.675,19.6097561 15.2083333,18.1268293 15.2083333,16.3658537 C15.2083333,14.604878 16.675,13.1219512 18.4166667,13.1219512 C20.1583333,13.1219512 21.625,14.604878 21.625,16.3658537 C21.625,18.1268293 20.1583333,19.6097561 18.4166667,19.6097561 Z"
      }));
    }
  }]);
  return Cycling;
}(_react["default"].PureComponent);

var _default = Cycling;
exports["default"] = _default;